import React from 'react';


const DraggableStable = () => {
    const data = {
        "config": {
            "zenPop": {
                "name": {
                    "typ": "newTab",
                    "route": "/lineperformance",
                    "params": {
                        "a": "n"
                    },
                    "multiProps": [
                        "_id"
                    ]
                },
                "age": {
                    "typ": "newTab",
                    "route": "/lineperformance",
                    "params": {
                        "ab": "mn"
                    },
                    "multiProps": [
                        "_id"
                    ]
                },
            },
            "columns": [
                {
                    "din": "name",
                    "colSize": 12,
                    "style": {
                        "backgroundColor": "red",
                        "color": "#ffffff",
                        "padding": 10
                    },
                    "zenPop": true
                },
                {
                    "din": "status",
                    "colSize": 12,
                    "style": {
                        "backgroundColor": "blue",
                        "color": "#ffffff",
                        "padding": 10
                    },
                    "zenPop": true
                },
                {
                    "din": "age",
                    "colSize": 12,
                    "style": {
                        "backgroundColor": "green",
                        "color": "#ffffff",
                        "padding": 10
                    },
                },
            ]
        },
        "data": [
            {
                "_id": 1,
                "name": "Test User 1",
                "status": "active",
                "age": 26
            },
            {
                "_id": 2,
                "name": "Test User 2",
                "status": "active",
                "age": 26
            },
            {
                "_id": 3,
                "name": "Test User 3",
                "status": "active",
                "age": 26
            }
        ]
    }
    return (
        <div>
            <table>
                <thead>
                    <th>Name</th>
                    <th>Status</th>
                    <th>Age</th>
                </thead>
                <tbody>
                    {
                        data.data.map((item, dIndex) => (
                            <tr draggable={true} >
                                {
                                    data.config.columns.map((col, cIndex) => (
                                        <td style={{ ...col.style }}>{item[col.din]}</td>
                                    ))
                                }
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        </div>
    )
};

export default DraggableStable;